import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from './config.service';
import { RuntimeSettings } from '../models/runtime-settings';

@Injectable({
  providedIn: 'root',
})
export class RuntimeSettingsService {

  private readonly runtimeSettingsSubject =
    new BehaviorSubject<RuntimeSettings>({
      entryLevelContractName: [],
      permanentContractName: [],
      subContractorContractName: [],
      secondaryPensionRatio: [],
      contractNames: [],
      activeSections: [],
      globalEmploymentType: [],

      academicalDegrees: [],          
      highSchoolDiplomaName: [], 

      contractTerminationCauses: [],


      afmaTypes: [],
      medicalVisitTypes: [],

      worklogGenerationMonth: 9,
      educationGrantMinAge: 3,
      educationGrantMaxAge: 16,
    });

  runtimeSettings$ =
    this.runtimeSettingsSubject.asObservable();

  constructor(
    private readonly configService: ConfigService
  ) {
    this.loadInitialValue();
  }

  private loadInitialValue(): void {
    this.configService
      .getRuntimeSettings()
      .subscribe((settings) => {
        this.runtimeSettingsSubject.next(settings);
      });
  }

  updateRuntimeSettings(
    settings: RuntimeSettings
  ): void {
    this.runtimeSettingsSubject.next(settings);
  }
}